import React, { Component } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import { SuiLabel, SuiTooltip, SuiContainer } from '@splashthat/sui';

const LabelContainer = styled(SuiContainer)`
    > :not(:last-child) {
        padding-bottom: 0.1rem;
    }
`;

const StyledTooltipContainer = styled.div`
    margin-left: 0.5rem;
`;

const StyledSuiLabel = styled(SuiLabel)`
    display: flex;

    ${(props) =>
        props.error &&
        `
        color: ${({ theme }) => theme.palette.danger.main}
    `}
`;

/**
 * Arrange two SuiLabels vertically, make the second one
 * "secondary", i.e. lighter/less emphasized.
 */
class LabelWithSecondaryText extends Component {
    static propTypes = {
        className: PropTypes.string,
        text: PropTypes.string,
        secondaryText: PropTypes.string,
        error: PropTypes.bool,
        helperText: PropTypes.string,
    };

    static defaultProps = {
        className: undefined,
        text: undefined,
        secondaryText: undefined,
        error: false,
        helperText: '',
    };

    render() {
        if (!this.props.secondaryText) {
            return <SuiLabel {...this.props} />;
        }

        return (
            <LabelContainer variation="flex-vertical" className={this.props.className}>
                <StyledSuiLabel {...this.props}>
                    {this.props.text}

                    {/**
                     * When helper text is passed as a prop, it shows as
                     * a SuiTooltip next to the main label.
                     */}
                    {this.props.helperText && (
                        <StyledTooltipContainer>
                            <SuiTooltip>{this.props.helperText}</SuiTooltip>
                        </StyledTooltipContainer>
                    )}
                </StyledSuiLabel>

                <SuiLabel secondary>{this.props.secondaryText}</SuiLabel>
            </LabelContainer>
        );
    }
}

export default LabelWithSecondaryText;
